import { render } from "./TenantDetails.vue?vue&type=template&id=349eeef2&scoped=true&ts=true"
import script from "./TenantDetails.vue?vue&type=script&lang=ts"
export * from "./TenantDetails.vue?vue&type=script&lang=ts"

import "./TenantDetails.vue?vue&type=style&index=0&id=349eeef2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349eeef2"]])

export default __exports__